import MD5 from 'crypto-js/md5';
import HmacSHA256 from 'crypto-js/hmac-sha256';
import Hex from 'crypto-js/enc-hex';
import Base64 from 'crypto-js/enc-base64';
const setCookie = function (name, value, timer) {
  let time = new Date();
  time.setTime(time.getTime() + timer * 60 * 1000);
  let expires = 'expires=' + time.toGMTString();
  document.cookie = name + '=' + value + '; ' + expires;
};

const getCookie = function (name) {
  name = name + '=';
  let cookie = document.cookie;
  let cookies = cookie.split(';');
  for (let item in cookies) {
    let value = cookies[item].trim();
    if (value.indexOf(name) === 0) {
      return value.slice(name.length, value.length);
    }
  }
  return '';
};

const getSign = function (path = '', method = '', date = '') {
  const host = 'account.zmrobo.com';
  const data = `${method} ${path} HOST ${host} DATE ${date} CLIENT`;
  const pathMd5 = MD5(path).toString(Hex);
  const base64 = HmacSHA256(data, pathMd5);
  const sign = Base64.stringify(base64);
  return sign;
};

const getOrderSign = function (path = '', method = '', date = '') {
  const data = `PATH ${path} METHOD ${method} AI DATE ${date}`;
  const pathMd5 = MD5(path).toString(Hex);
  const base64 = HmacSHA256(data, pathMd5);
  const sign = Base64.stringify(base64);
  return sign;
};

export { getSign, getOrderSign, setCookie, getCookie };
